<template>
	<div class="fixed-header">
  <div>
    <div class="br-pagetitle d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center pos-relative">
        <i class="icon ion-aperture"></i>
        <div class="mg-l-20">
          <h4>
            {{$t('product.新品推荐')}}
          </h4>
        </div>
      </div>
      <div class="tx-right d-flex align-items-center">
        <router-link data-v-id="step7" class="mg-r-15 btn btn-success" target="_blank" :to="'/create-new-pro'">{{$t('product.手工添加新品')}}</router-link>
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-start pd-x-20 pd-sm-x-30">
      <div class="clear-key">
        <a v-show="key_name" href="javascript:;" class=" mg-r-15" @click="clearKey('name')">
          {{$t('product.商品名')}}：
          <span class="mg-r-10">{{key_name}}</span>
          <i class="fa fa-close"></i>
        </a>
        <a v-show="key_sku" href="javascript:;" class=" mg-r-15" @click="clearKey('sku')">
          SKU：
          <span class="mg-r-10">{{key_sku}}</span>
          <i class="fa fa-close"></i>
        </a>
        <a v-show="key_spu" href="javascript:;" class=" mg-r-15" @click="clearKey('spu')">
          SPU：
          <span class="mg-r-10">{{key_spu}}</span>
          <i class="fa fa-close"></i>
        </a>
         <a v-show="key_status" href="javascript:;" class=" mg-r-15" @click="clearKey('status')">
          {{$t('product.状态')}}：
          <span class="mg-r-10">{{$t($dict.newProStatus[key_status])}}</span>
          <i class="fa fa-close"></i>
        </a>
        <a v-show="key_soldstatus" href="javascript:;" class=" mg-r-15" @click="clearKey('soldStatus')">
          {{$t('product.销售状态')}}：
          <span class="mg-r-10">{{$t($dict.newProSoldStatus[key_soldstatus])}}</span>
          <i class="fa fa-close"></i>
        </a>
        <a v-show="date_from || date_to" href="javascript:;" class=" mg-r-15" @click="clearKey('date')">
          {{$t('product.创建时间')}}：
          <span class="mg-r-10">{{date_from}} ~ {{date_to}}</span>
          <i class="fa fa-close"></i>
        </a>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  props:["date_from","date_to","key_sku", "key_name", "key_scale", "key_status","key_spu","key_soldstatus","userInfo"],
  data() {
    return {
    	userinfo: JSON.parse(localStorage.getItem("userInfo")),
    };
  },
  computed: {
    active() {
      return this.key_name || this.key_sku || this.key_status || this.key_spu || this.key_soldstatus || this.date_from || this.date_to
        ? true
        : false;
    }
  },
  methods:{
  	clearKey(type) {
      this.$emit("clearKey", type);
    },
  }
}
</script>

